import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
import back1 from '../../../assets/images/backgrounds/back1.jpg';
import back2 from '../../../assets/images/backgrounds/back2.jpg';
import back3 from '../../../assets/images/backgrounds/back3.jpg';
import back4 from '../../../assets/images/backgrounds/back4.jpg';

const Hero = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      background: back1,
      title: 'Créez Votre Espace de Travail Idéal',
      subtitle: 'Découvrez notre collection premium de meubles de bureau conçus pour votre confort et productivité',
      primaryBtn: 'Découvrir les Produits',
      primaryLink: '/products',
      secondaryBtn: 'Nos Showrooms',
      secondaryLink: '/contact'
    },
    {
      id: 2,
      background: back2,
      title: 'Où le Confort Rencontre l\'Excellence',
      subtitle: 'Transformez votre bureau en un sanctuaire de créativité avec nos designs sophistiqués et ergonomiques',
      primaryBtn: 'Explorer la Collection',
      primaryLink: '/products',
      secondaryBtn: 'Inspiration Design',
      secondaryLink: '/about'
    },
    {
      id: 3,
      background: back3,
      title: 'L\'Art de Travailler avec Style',
      subtitle: 'Chaque meuble raconte une histoire de raffinement, alliant esthétique intemporelle et fonctionnalité moderne',
      primaryBtn: 'Voir les Nouveautés',
      primaryLink: '/products',
      secondaryBtn: 'Nos Réalisations',
      secondaryLink: '/about'
    },
    {
      id: 4,
      background: back4,
      title: 'Investissez dans Votre Productivité',
      subtitle: 'Des espaces qui inspirent, des meubles qui durent. Découvrez l\'excellence à chaque détail',
      primaryBtn: 'Offres Exclusives',
      primaryLink: '/products',
      secondaryBtn: 'Contactez-nous',
      secondaryLink: '/contact'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000); // Change slide every 6 seconds

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <section className="carousel-hero">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`carousel-hero__background ${index === currentSlide ? 'carousel-hero__background--visible' : ''}`}
          style={{
            backgroundImage: `url(${slide.background})`,
          }}
        >
          <div className="carousel-hero__backdrop"></div>
        </div>
      ))}

      <div className="container carousel-hero__wrapper">
        <div className="carousel-hero__stage">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`carousel-hero__panel ${index === currentSlide ? 'carousel-hero__panel--visible' : ''}`}
            >
              <h1 className="carousel-hero__heading">{slide.title}</h1>
              <p className="carousel-hero__description">{slide.subtitle}</p>
              <div className="carousel-hero__buttons">
                <button 
                  className="carousel-btn carousel-btn--primary"
                  onClick={() => handleNavigation(slide.primaryLink)}
                >
                  {slide.primaryBtn}
                </button>
                <button 
                  className="carousel-btn carousel-btn--secondary"
                  onClick={() => handleNavigation(slide.secondaryLink)}
                >
                  {slide.secondaryBtn}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;